import { useState } from "react";
import { toast } from "sonner";
import { http, errMsg } from "../../lib/api";

const field = "w-full rounded-xl border border-cyan-400/20 bg-[#050911] px-4 py-3 text-sm text-white outline-none focus:border-cyan-400/70";

export const PostForm = ({ initial, onClose, onSaved }) => {
  const [f, setF] = useState({
    kind: initial.kind || "update", title: initial.title || "", tag: initial.tag || "",
    content: initial.content || "", image_url: initial.image_url || "",
  });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      if (initial.id) await http.put(`/posts/${initial.id}`, f);
      else await http.post("/posts", f);
      toast.success(initial.id ? "Post updated" : "Post published");
      onSaved();
    } catch (err) { toast.error(errMsg(err)); } finally { setSaving(false); }
  };

  return (
    <form onSubmit={save} data-testid="admin-post-form" className="mb-6 space-y-3 rounded-2xl border border-cyan-400/30 bg-[#0A101D] p-5">
      <div className="flex gap-2">
        {["update", "leak"].map((k) => (
          <button type="button" key={k} onClick={() => setF({ ...f, kind: k })} data-testid={`admin-kind-${k}`}
            className={`rounded-full px-4 py-1.5 font-mono text-xs uppercase tracking-[0.15em] border ${f.kind === k ? (k === "leak" ? "border-red-400 bg-red-500/15 text-red-300" : "border-cyan-400 bg-cyan-400/15 text-[#00E5FF]") : "border-slate-700 text-slate-400"}`}>
            {k}
          </button>
        ))}
      </div>
      <input required placeholder="Title" value={f.title} onChange={set("title")} className={field} data-testid="admin-post-title-input" />
      <input placeholder="Tag (e.g. Patch notes, Top secret)" value={f.tag} onChange={set("tag")} className={field} data-testid="admin-post-tag-input" />
      <textarea required rows={5} placeholder="Content" value={f.content} onChange={set("content")} className={field} data-testid="admin-post-content-input" />
      <input placeholder="Image URL (optional)" value={f.image_url} onChange={set("image_url")} className={field} data-testid="admin-post-image-input" />
      <div className="flex justify-end gap-2">
        <button type="button" onClick={onClose} data-testid="admin-post-cancel-button" className="rounded-full px-4 py-2 font-mono text-xs uppercase text-slate-300 hover:text-white">Cancel</button>
        <button type="submit" disabled={saving} data-testid="admin-post-save-button" className="rounded-full bg-[#00E5FF] px-5 py-2 font-mono text-xs font-bold uppercase text-[#050911] hover:bg-white">
          {saving ? "Saving…" : initial.id ? "Save changes" : "Publish"}
        </button>
      </div>
    </form>
  );
};
